import styled from 'styled-components';
import { typeStyle } from '../../styles/config/typeStyles';
import { theme } from '../../styles/config/theme';
import { Link } from 'react-router-dom';
import { rgba } from 'polished';
import media from '../../styles/config/mediaQueries';

const StyledImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: 0.75s ease;
  transition-property: transform;
`;

const StyledBox = styled.li`
  position: relative;
  list-style: none;
  ${media.mobile`
    width: calc(100% + 86px);
    height: 143px;
    margin-bottom: 10px;
  `}
  ${media.desktop`
    width: calc(33.1025% - 30px);
    margin: 0 15px 13px;
    &:hover {
      ${StyledImage} {
        transform: scale(1.15);
      }
    }
  `}
`;

const StyledContainer = styled(Link)`
  display: flex;
  height: 100%;
  width: 100%;
  ${media.mobile`
    position: absolute;
    left: 2px;
    top: 0;
    align-items: flex-end;
    padding: 18px 24px;
    background-color: ${() => theme.color.black};
    border-radius: 20px;
    overflow: hidden;
  `}
  ${media.desktop`
    position: static;
    flex-direction: column;
    border-radius: 0;
  `}
`;

const StyledLabel = styled.span`
  background-color: ${props => theme.color[props.color] || theme.color.white};
  ${media.mobile`
    position: absolute;
    left: 0;
    top: 10px;
    bottom: 10px;
    width: 132px;
    border-radius: 10px;
  `}
  ${media.desktop`
    position: static;
    height: 1px;
    width: 90%;
    margin: 0 auto;
  `}
`;

const StyledTextContent = styled.div`
  ${media.desktop`
    border-top: 0;
    flex-grow: 1;
    text-align: center;
    padding: 16px 20px 35px;
    border: 1px solid ${rgba(theme.color.white, 0.2)};
    border-top: 0;
    position: relative;
    transform: translateY(-2px);
  `}
`;

const StyledTitle = styled.h2`
  text-transform: uppercase;
  ${media.mobile`
    ${typeStyle.h1};
    position: relative;
    line-height: 1.25;
    max-width: 283px;
    z-index: 2;
  `}
  ${media.desktop`
    ${typeStyle['font-18-bold']};
    margin-bottom: 6px;
  `}
`;

const StyledDescription = styled.p`
  ${typeStyle['font-12']}
`;

const StyledBgImage = styled.div`
  width: 100%;
  &:after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
  ${media.mobile`
    height: 100%;
    position: absolute;
    left: 2px;
    top: 0;
    z-index: 1;
    &:after {
      background-color: ${rgba(theme.color.black, 0.2)};
    }
  `}
  ${media.desktop`
    height: 120px;
    overflow: hidden;
    position: relative;
    &:after {
      background-color: ${rgba(theme.color.black, 0.3)};
    }
  `}
`;

const StyledOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: ${props => props.bgColor};
  z-index: 2;
  opacity: 0.6;
`;

const StyledIcon = styled.img`
  max-width: 200px;
  max-height: 74px;
  object-fit: contain;
  z-index: 3;
  ${media.mobile`
    position: relative;
    margin-bottom: 6px;
  `}
  ${media.desktop`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  `}
`;

export {
  StyledBox,
  StyledOverlay,
  StyledIcon,
  StyledContainer,
  StyledLabel,
  StyledTextContent,
  StyledTitle,
  StyledDescription,
  StyledBgImage,
  StyledImage,
};
